/**
 * @Description: 全局定义请求接口异常提示语
 * @author jing
 * @date: 2020/10/12 14:00
 * @params:
 */
export default {
  '403': '没有权限',
  '999999': '系统繁忙，请重新尝试',
  '999995': '账号已被停用',
  '110503': '订单所在包裹为合并包裹，请选择整包裹放行或取消操作',
  '110607': '买家地址为空,标记付款失败',
  '110252': '匹配商品/映射已删除',
  '111102': '请选择物流商',
  '310017': '包裹已截留',
  '110254': '查询交易异常',
  '111117': '查询不到相关的包裹',
  '106101': '帐号已存在',
  '106102': '帐号不匹配',
  '108101': '代号已存在',
  '220001': '代号已存在',
  '101107': '权限资源不能为空',
  '101104': '菜单key已存在',
  '101106': '非法的菜单key',
  '101103': '角色名已存在',
  '7100241': '渠道代码已存在',
  '270001': '纠纷已关闭',
  '111150': '包裹状态已变更,操作异常',
  '119201': '物流名称已存在',
  '553513': '存在分仓规则使用该仓库权重作为判断条件，不能停用',
  '554121': '仓库名称已存在',
  '333005': '后台数据有更新，请刷新列表后重试',
  '119101': '物流商账号名称已存在',
  '110245': '请先选择仓库后保存',
  '111174': '更新发货系统邮寄方式异常：正在上传物流，无法取消物流',
  '111173': '取消物流失败',
  '110259': '部分订单状态已修改,请刷新后重试',
  '110602': '调用取消订单接口失败',
  '110263': '该订单存在已经发货的包裹,不允许作废或取消订单!',
  '310001': '包材名称已存在',
  '310002': '包材名称存在重复',
  '210028': '无导出数据,请选择后再试',
  '110249': '回复站内信失败',
  '111130': '非拆分单不能重置包裹',
  '111001': '新包裹信息保存失败',
  '111115': '订单中有已存在包裹的订单,操作失败',
  '110603': '订单ID不能为空',
  '110606': '无可合并订单',
  '111132': '无可合并订单',
  '111131': '存在作废或有留言或截留订单,合并失败',
  '111123': '包裹已作废',
  '111120': '拆分单不能合并',
  '111119': '包裹中存在将追加进的订单',
  '111116': '包裹数据发生变化',
  '110222': '合并包裹失败',
  '710024': '未下载到paypal交易,操作失败',
  '110258': '商品不存在或商品停售',
  '107106': 'paypal退款失败',
  '107100': '帐号已存在',
  '107103': 'PayPal授权失败',
  '116201': '固定周期设置时间需要大于1',
  '116202': '开启每天定时设置时间点不能为空',
  '119100': '物流商名称已存在',
  '119107': '物流商不存在',
  '119108': '物流商代码已存在',
  '119129': '物流商编码为空',
  '119130': '物流商名称为空',
  '119105': '获取物流商详情异常',
  '119117': '平台帐号不存在',
  '119128': '平台帐号已停用',
  '119126': '默认分区外计费模型国家不能为空',
  '119120': '全球可达不可删除默认分区',
  '119121': '非全球可达应无默认分区',
  '119123': '可达类型错误',
  '119127': '渠道编码已存在',
  '1111': '仓库代码不能重复',
  '610004': '库区组仓库必须和库区仓库一致',
  '610005': '只有标准区和良品区可以绑定商品分类',
  '610006': '只有标准区和良品区可以绑定商品sku',
  '610007': 'sku已经绑定在其库区',
  '121007': '存在商品在使用该品牌，不能删除!',
  '121002': '品牌名称已存在',
  '121003': '分类ID已存在',
  '121004': '当前分类下存在商品，不允许删除',
  '121005': '当前分类下存在子分类，不允许删除',
  '710015': '请选择相关售后操作',
  '710017': '退款金额超过支付金额',
  '710013': '退款金额不能大于交易金额',
  '710002': '专有黑名单已存在',
  '710006': '订单号不存在',
  '20038': '分段计费表格参数不匹配或不完整',
  '710007': '审批状态已修改,操作失败',
  '710009': '创建退货入库单异常',
  '710010': '创建补货单异常',
  '710014': '已退款,请勿重复退款',
  '710011': '订单存在多个交易,退款失败',
  '710008': '售后退货货品为空',
  '119113': '授权失败',
  '410001': '不存在该规则',
  '110121': '标签名称已存在',
  '110111': '不能删除存在关联的标签',
  '210055': 'sku与upc不可重复',
  '210062': '该SKU有未下单的采购订单不允许删除',
  '210053': 'upc已存在',
  '210054': 'UPC存在重复',
  '210032': '设置组装商品中原材料包含组装商品',
  '210056': '存在SPU和当前SKU是一样的,不允许添加映射,请先把SPU调整后重新关联',
  '270999': '调ebay接口失败',
  '240002': '代号已存在',
  '210001': '编码已存在',
  '210010': '属性不合法',
  '210012': '参数存在相同属性',
  '210014': '货品属性key不一致',
  '210011': '存在相同属性SKU',
  '210029': '只能包含以下字符 0-9, #, &, +, -, ., /, A-Z, [, ], ^, _, a-z, { }, , ~',
  '102010': '保存失败，邮箱已被占用',
  '101102': '删除失败，角色正在使用',
  '107102': '账号已授权',
  '121009': '商品标签不能包含逗号',
  '1210010': '商品标签不能包含空格',
  '121001': '标签名称已存在',
  '102013': '手机已绑定,不支持更新手机',
  '333001': '存在相同的规则名称',
  '333013': '未设置触发时间',
  '110237': '更新发货系统邮寄方式异常',
  '340001': '没有需要标记为已读的站内信',
  '6100061': '没有需要标记为已读的站内信',
  '320001': '该平台已经存在这个运输方式，无需重复添加',
  '400000': '一个货品一个店铺只能设置一个带电资质',
  '554102': '分区使用中不能删除',
  '554115': '分区分方案名称不能重复',
  '510001': '文件夹名称已存在!',
  '510011': '已经是第一个了',
  '510002': '参数不正确',
  '510003': '模板分类名称重复',
  '554127': '库位编码已存在',
  '554116': '分区代码不能重复',
  '510005': '模板编号重复',
  '610002': '库区组名称重复',
  '610001': '库区组已关联库区,删除失败',
  '710005': '添加重复',
  '9999': '验证邮箱失败',
  '210002': 'SPU或SKU存在重复',
  '210009': '加载filenode图片异常',
  '270008': '没有可同步的纠纷',
  '210013': '属性不合法',
  '210017': '分类不存在',
  '210019': '上传图片路径为空',
  '210031': '变参商品SKU不能与SPU重复',
  '210033': '设置组装商品中包含无效货品',
  '210050': '其中有原料正在被组装商品使用，不能删除',
  '210018': '该商品正在被映射商品使用，不能删除',
  '210015': 'SKU不存在',
  '310016': '包材编号已经存在',
  '210058': '该SKU有库存不允许删除',
  '554137': '不良品库位只能增加到不良品区',
  '554140': '同仓库下店铺不能重复',
  '102018': '手机号已经被占用',
  '210059': '非草稿状态不能删除',
  '210061': '待审核不能修改中文名称,英文名称,标题,图片',
  '710025': '添加货品数量超量',
  '710026': '添加包裹货品数量与原包裹一致',
  '110216': '操作成功,创建出库单失败!请查看订单日志',
  '110212': '订单不存在',
  '710028': '速卖通认证仓订单申请取消中',
  '710029': '速卖通认证仓订单已发货',
  '710030': '订单已取消',

  '446056': '添加失败:SKC颜色不可重复!',
  '440000': '尺码不可重复，保存失败!',
  '446092': '分类类型重复!',
  '446093': '开始字符重复!',
  '106100': '帐号已存在',
  '106104': '帐号不匹配',
  '106105': '查询开发者帐号异常',
  '106999': '其他异常',
  '310008': '获取token异常',
  '240001': '商户id不存在',
  '310009': '调用channel异常',
  '220002': '帐号已存在',
  '220003': '帐号不匹配',
  '220004': 'LOGINID已存在',
  '507006': '邮箱已存在',
  '507005': '查询开发者帐号异常',
  '507007': '该站点不存在开发者账号信息',
  '108999': '账户不存在',
  '106103': '查询开发者帐号异常',
  '107000': '授权失败',
  '107001': '帐号编码已存在',
  '107002': '获取开发者帐号异常',
  '108102': '帐号不匹配',
  '108103': '授权异常',
  '108104': '帐号不存在',
  '107003': '帐号不存在',
  '107004': '帐号不匹配',
  '107005': '获取token异常',
  '507001': '帐号编号已存在',
  '507002': '帐号不匹配',
  '507003': '国家不匹配',
  '507999': '获取refresh token异常',
  '108100': '帐号已存在',
  '107101': '账号不存在',
  '107104': '推送任务异常',
  '107105': '删除任务异常',
  '607001': '帐号编号已存在',
  '108105': '已经授权成功过的不能修改shopname',
  '500003': 'skc码已经存在',
  '106107': '站点错误',
  '1210015': '属性别名已存在',
  '106108': '参数错误',
  '710033': '导出数量大于十万条'
};
